import { fortnoxAuthService } from '@/services/auth/fortnox-auth-service';
import { computed, type Ref } from 'vue';

interface UseFortnoxAccountHandlerLogicProps {
  authenticated: Ref<boolean>;
  account: Ref<Awaited<ReturnType<typeof fortnoxAuthService.getMe>> | null>;
}

export function useFortnoxAccountHandlerLogic(
  props: UseFortnoxAccountHandlerLogicProps,
) {
  const fortnoxLogin = () => {
    if (props.authenticated.value) {
      return;
    }
    fortnoxAuthService.login();
  };

  const fortnoxLogout = () => {
    fortnoxAuthService.logout();
    props.authenticated.value = false;
    props.account.value = null;
  };

  const handleEvents = (event: { type: 'connect' | 'disconnect' }) => {
    if (event.type === 'connect') {
      fortnoxLogin();
    } else if (event.type === 'disconnect') {
      fortnoxLogout();
    }
  };

  const state = computed(() => ({
    status: props.authenticated.value
      ? ('connected' as const)
      : ('disconnected' as const),
    account: props.account.value
      ? {
          id: props.account.value.id,
          name: props.account.value.name,
        }
      : null,
  }));

  return {
    handleEvents,
    state,
  };
}
